<template>
  <div class="d-flex flex-nowrap" style="max-height: 48px;">
    <v-tooltip location="bottom" open-delay="100">
      <template v-slot:activator="{ props }">
        <v-btn
          v-bind="props"
          variant="text"
          style="margin: 0 16px"
          class="top-nav"
          icon="mds:home"
          :active="$route.path === '/dashboard/'"
          @click="$router.push('/dashboard/').catch(() => {})"
        />
      </template>
      Home (all projects)
    </v-tooltip>

    <v-tooltip location="bottom" open-delay="100">
      <template v-slot:activator="{ props }">
        <span v-if="$route.path === '/settings'">
          My Organisations
        </span>
        <span
          v-else
          v-bind="props"
          style="vertical-align: middle; cursor: pointer;"
          class="text-truncate"
          @click="$router.push('/dashboard/').catch(() => {})"
        >
          {{ getBredcrumbProjectText(project) }}
        </span>
      </template>
      Home (all projects)
    </v-tooltip>

    <span>
      <v-icon v-if="project" class="mx-1" style="padding-bottom: 2px;" size="small">mds:arrow-forward-ios</v-icon>
    </span>

    <v-tooltip v-if="project" location="bottom" open-delay="100">
      <template v-slot:activator="{ props }">
        <span
          v-bind="props"
          style="cursor: pointer;"
          class="text-truncate"
          @click="$store.state.workflow.isViewOnlyEnabled ?
            $router
              .push(`/dashboard`)
              .catch() :
            $router
              .push(`/dashboard/${project.id}`)
              .catch(() => {})
          "
        >
          {{ project.name }}
        </span>
      </template>
      Project dashboard
    </v-tooltip>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  methods: {
    getBredcrumbProjectText (project) {
      if (project?.organisation?.name) {
        return project.organisation.name
      }
      if (this.$route.params.projectId) {
        return 'Public'
      }
      return ''
    }
  },
  computed: {
    ...mapGetters({
      project: 'projectMemberships/activeProject'
    })
  }
}
</script>

<style>
.projects-list-menu {
  max-height: calc(100vh - 20px);
}

.v-tooltip__content {
  background: white;
  color: var(--color-primary);
  border-radius: 10px;
}
</style>
